import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';

const accessLabels = { manage: 'Gerenciar', view: 'Visualizar', none: 'Sem acesso' };

function Badge({ kind }) {
  const map = {
    manage: 'bg-primary-container text-on-primary-container',
    view: 'bg-secondary-container text-on-secondary-container',
    none: 'bg-surface-variant text-on-surface-variant',
  };
  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full font-label-sm text-label-sm ${map[kind]}`}>
      {accessLabels[kind]}
    </span>
  );
}

export default function Permissions() {
  const [matrix, setMatrix] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.roles().then(setMatrix).catch((e) => setError(e.message));
  }, []);

  if (error) return <p className="text-[11px] text-error">{error}</p>;
  if (!matrix) return <p className="text-[11px] text-on-surface-variant">Carregando…</p>;

  const caps = Object.keys(accessLabels);

  return (
    <div className="flex flex-col gap-base">
      <div>
        <h1 className="studio-uniform-title font-h2 text-h2 text-on-surface">Permissões e Perfis</h1>
        <p className="font-body-md text-body-md text-on-surface-variant mt-2">
          Matriz de acesso por perfil (Admin, Designer, Operador) no Studio.
        </p>
      </div>

      <div className="bg-surface rounded-2xl shadow-sm overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-surface-container-lowest text-on-surface-variant font-label-sm text-label-sm uppercase tracking-wider">
              <th className="px-6 py-4 font-semibold w-64">Perfil</th>
              {caps.map((c) => (
                <th key={c} className="px-6 py-4 font-semibold capitalize">
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-surface-container-highest font-body-md text-body-md text-on-surface">
            {matrix.map(({ role, label, users, templates, dashboard }) => (
              <tr key={role} className="hover:bg-surface-container-low transition-colors">
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-secondary-container text-on-secondary-container flex items-center justify-center font-bold text-[14px]">
                      {label[0]}
                    </div>
                    <div className="flex flex-col">
                      <span className="font-semibold">{label}</span>
                      <span className="text-on-surface-variant text-[11px]">{role.toLowerCase()}</span>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <Badge kind={users} />
                </td>
                <td className="px-6 py-4">
                  <Badge kind={templates} />
                </td>
                <td className="px-6 py-4">
                  {dashboard ? <Badge kind="view" /> : <Badge kind="none" />}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}


